import { render, staticRenderFns } from "./Targeting.vue?vue&type=template&id=4e641542&scoped=true"
import script from "./Targeting.vue?vue&type=script&lang=js"
export * from "./Targeting.vue?vue&type=script&lang=js"
import style0 from "./Targeting.vue?vue&type=style&index=0&id=4e641542&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e641542",
  null
  
)

export default component.exports